import { render, staticRenderFns } from "./configuracaoContaGeral.vue?vue&type=template&id=a191ff86"
import script from "./configuracaoContaGeral.vue?vue&type=script&lang=js"
export * from "./configuracaoContaGeral.vue?vue&type=script&lang=js"
import style0 from "./configuracaoContaGeral.vue?vue&type=style&index=0&id=a191ff86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports